import { UploadOutlined } from "@ant-design/icons";
import { App, Button, Spin, Upload } from "antd";
import { useAuth } from "$context/AuthContextProvider";
import { useQueryClient } from "@tanstack/react-query";

const ImportButton = ({ isLoading, setLoadingComponent }) => {
  const { notification } = App.useApp();

  const { bearerToken } = useAuth();
  const queryClient = useQueryClient();

  const props = {
    name: "file",
    action: `${process.env.REACT_APP_API_URL}/csv_file/import`,
    headers: {
      authorization: `Bearer ${bearerToken}`,
    },
    accept: ".csv",
    showUploadList: false,
    onProgress: () => {
      setLoadingComponent((loading) => ({ ...loading, import: true }));
    },
    onError: (event, body) => {
      setLoadingComponent((loading) => ({ ...loading, import: false }));
      notification.error({
        message: body.detail || "Import fehlgeschlagen.",
        duration: 100,
      });
      queryClient.invalidateQueries({ queryKey: ["attributes"] });
    },
    onSuccess: (info) => {
      setLoadingComponent((loading) => ({ ...loading, import: false }));
      notification.success({
        message: info,
      });
      queryClient.invalidateQueries({ queryKey: ["attributes"] });
    },
  };

  const onChange = (info) => {
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === "done") {
      notification.success({
        message: `${info.file.name} file uploaded successfully`,
      });
    } else if (info.file.status === "error") {
      notification.error({ message: `${info.file.name} file upload failed.` });
    }
  };
  return (
    <Upload {...props} onChange={onChange}>
      <Button
        icon={<UploadOutlined />}
        disabled={isLoading.import || isLoading.export || isLoading.delete}
      >
        {isLoading.import ? (
          <div>
            <Spin /> Importiere...
          </div>
        ) : (
          "Datenimport"
        )}
      </Button>
    </Upload>
  );
};

export default ImportButton;
